'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_648c7803 = {"container":"Thead_module_container__4c9d46d5"};
require("../../../assets/cjs/components/Table/src/Thead~BDb0lei6.css");

exports.default = modules_648c7803;
//# sourceMappingURL=Thead.module.less.js.map
